import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, Paperclip, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const fmtDate = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleString("it-IT", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
};

export default function Communications() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/communications")
            .then(({ data }) => setItems(data))
            .catch((e) => console.error("Load communications failed:", e))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="max-w-4xl mx-auto" data-testid="communications-page">
            <div className="mb-6">
                <div className="inline-flex items-center gap-2 bg-[#C7FF2C]/30 text-[#0C4650] px-3 py-1 rounded-full text-xs font-bold">
                    <Megaphone className="w-3 h-3" /> AREA AGENTE
                </div>
                <h1 className="mt-3 text-3xl sm:text-4xl font-black text-[#0C4650]">
                    Comunicazioni
                </h1>
                <p className="text-gray-600 mt-1 max-w-2xl">
                    Storico di tutte le comunicazioni, offerte e aggiornamenti ricevuti dalla sede.
                </p>
            </div>

            {loading ? (
                <div className="card p-10 flex items-center justify-center">
                    <Loader2 className="w-6 h-6 animate-spin text-[#0C4650]" />
                </div>
            ) : items.length === 0 ? (
                <div className="card p-10 text-center" data-testid="no-communications">
                    <Megaphone className="w-10 h-10 text-gray-300 mx-auto mb-3" />
                    <h2 className="text-lg font-black text-[#0C4650]">
                        Nessuna comunicazione
                    </h2>
                    <p className="text-sm text-gray-500 mt-1">
                        Quando la sede ti invierà novità, offerte o aggiornamenti, li troverai qui.
                    </p>
                </div>
            ) : (
                <div className="space-y-3">
                    {items.map((c) => (
                        <Link
                            key={c.id}
                            to={`/comunicazioni/${c.id}`}
                            className="card p-5 flex items-start gap-4 hover:border-[#0C4650] transition-all block"
                            data-testid={`communication-${c.id}`}
                        >
                            <div className={`w-11 h-11 shrink-0 rounded-xl flex items-center justify-center ${
                                c.read_at ? "bg-gray-100 text-gray-400" : "bg-[#C7FF2C] text-[#0C4650]"
                            }`}>
                                <Megaphone className="w-5 h-5" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-start justify-between gap-3 flex-wrap">
                                    <h3 className={`font-black text-base text-[#0C4650] ${
                                        c.read_at ? "" : "after:content-['•'] after:ml-2 after:text-[#C7FF2C] after:text-2xl after:leading-none"
                                    }`}>
                                        {c.subject}
                                    </h3>
                                    <span className="text-[11px] text-gray-500 whitespace-nowrap">
                                        {fmtDate(c.created_at)}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                                    {c.message}
                                </p>
                                {c.attachment_name && (
                                    <div className="inline-flex items-center gap-1.5 mt-2 text-xs font-bold text-[#0C4650] bg-[#C7FF2C]/30 px-2 py-1 rounded-full">
                                        <Paperclip className="w-3 h-3" />
                                        {c.attachment_name}
                                    </div>
                                )}
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
